import React, { useContext, useMemo, useState } from "react";
import { ScreenLoaderContext } from "shared-library";

// export const ScreenLoaderContext = createContext({
//   startLoader: null,
//   stopLoader: null,
// });

export const ScreenLoaderProvider = ({ children }) => {
  const [loader, setLoader] = useState([]);

  const startLoader = (process) => setLoader((prev) => [...prev, process]);

  const stopLoader = (process) => setLoader((prev) => prev.filter((item) => item !== process));

  const values = { loader, startLoader, stopLoader };

  return (
    <ScreenLoaderContext.Provider value={useMemo(() => values, [values])}>
      {loader.length > 0 && (
        <div className="fixed bg-white bg-opacity-60 z-[999999999] h-full w-full flex items-center justify-center left-0 top-0">
          <div className="flex items-center">
            <div className="animate-spin rounded-full h-32 w-32 border-t-4 border-b-4 border-primary"></div>
          </div>
        </div>
      )}
      {children}
    </ScreenLoaderContext.Provider>
  );
};

export const useScreenLoader = () => useContext(ScreenLoaderContext);
